import { BaseService } from "./base/BaseService"

export const getAuthUrl = (redirect_uri) => {
    return BaseService.get('/auth/get-url', {redirect_uri})
}

export const exchangeCode = (redirect_uri, code) => {
    return BaseService.get('/auth/exchange-code', {redirect_uri, code})
}